import React from 'react';
import { KeyStatusCounts } from '../../Helpers/keyRegisterUtils';
import { KEY_STATUSES } from '../../types/keyRegister';

interface KeyStatusBarProps {
    counts: KeyStatusCounts;
    className?: string;
}

/** A stacked horizontal bar of the status counts, coloured per status (`.key-bar-seg--{status}`). Decorative. */
const KeyStatusBar: React.FC<KeyStatusBarProps> = ({ counts, className }) => {
    const total = KEY_STATUSES.reduce((sum, status) => sum + counts[status], 0);
    return (
        <span className={`key-bar${className ? ` ${className}` : ''}`} aria-hidden="true">
            {total > 0 && KEY_STATUSES.filter(status => counts[status] > 0).map(status => (
                <span key={status} className={`key-bar-seg key-bar-seg--${status}`} style={{ width: `${(counts[status] / total) * 100}%` }} />
            ))}
        </span>
    );
};

export default KeyStatusBar;
